<template>
  <div class="brb-modal">
    <slot v-if="!noActivator" name="activator" :show="show" :hide="hide">
      <component
        v-if="!noActivator"
        :is="activatorTag"
        v-bind="activatorAttrs"
        :text="activatorLabel"
        @click="show"
      />
    </slot>

    <b-modal
      v-model="open"
      v-bind="$attrs"
      v-on="$listeners"
      :content-class="['rounded-modal', { 'overflow-hidden': !showOverflow }]"
      body-class="p-0"
      hide-header
      hide-footer
    >
      <div
        v-if="!noHeader"
        class="head d-flex align-items-center justify-content-between bg-light p-3"
      >
        <slot name="header" :show="show" :hide="hide">
          <h4 class="text-muted p-0 m-0 single-line">
            {{ title }}
          </h4>
        </slot>

        <b-btn
          v-if="closeButton"
          variant="link"
          size="sm"
          :disabled="loading"
          @click="hide"
        >
          <font-awesome-icon icon="times" class="text-muted align-middle" />
        </b-btn>
      </div>

      <b-overlay :show="loading">
        <slot></slot>

        <div
          v-if="!noFooter"
          class="foot d-flex align-items-center justify-content-end bg-light p-3"
        >
          <slot name="footer-start"></slot>

          <slot name="footer" :show="show" :hide="hide">
            <b-btn variant="danger" class="px-4 ml-2" @click="cancel">
              {{ cancelLabel }}
            </b-btn>

            <b-btn
              variant="success"
              class="px-4"
              @click="$emit('submit', { show, hide })"
            >
              {{ submitLabel }}
            </b-btn>
          </slot>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'BrbModal',
  props: {
    value: {
      type: Boolean,
      default: null
    },
    activatorTag: {
      type: String,
      default: 'brb-btn'
    },
    activatorAttrs: Object,
    activatorIcon: String,
    activatorIconClass: [String, Array, Object],
    activatorLabel: {
      type: String,
      default: function () {
        return this.$t('fileManager.open')
      }
    },
    title: {
      type: String,
      default: null
    },
    submitLabel: {
      type: String,
      default: function () {
        return this.$t('shared.confirm')
      }
    },
    cancelLabel: {
      type: String,
      default: function () {
        return this.$t('shared.cancel')
      }
    },
    noActivator: Boolean,
    showOverflow: Boolean,
    noHeader: Boolean,
    noFooter: Boolean,
    closeButton: Boolean,
    loading: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      open: false
    }
  },
  watch: {
    value(value) {
      this.open = value
    },
    open(value) {
      this.$emit('input', value)
    }
  },
  methods: {
    show() {
      if (this.disabled) return
      this.open = true
    },
    hide() {
      this.open = false
    },
    cancel() {
      this.hide()
    }
  }
}
</script>
